export default __webpack_public_path__ + "static/media/pizzas-5.0acfa8f8.jpg";